
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class HelpTextGrid extends SiteEntityGrid<HelpTextRow, any> {
        protected getColumnsKey() { return 'Data.HelpText'; }
        protected getDialogType() { return HelpTextDialog; }
        protected getIdProperty() { return HelpTextRow.idProperty; }
        protected getLocalTextPrefix() { return HelpTextRow.localTextPrefix; }
        protected getService() { return HelpTextService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}